export default "__VITE_ASSET__CBQzbHaB__"